<template>
<div class="popup" v-cloak v-show="taskCancelShow">
    <div class="content" id="taskCancel">
        <div class="title">
            <span>{{$t('language.popup.remoteTaskPopup.cancelTask')}}</span>
            <div class="icon white-close dialog-close" @click="taskCancelShow=false"></div>
        </div>
        <div class="delete-content">
            <span>{{$t('language.popup.remoteTaskPopup.cancelTaskContent')}}</span>
        </div>
        <div class="delete-footer">
            <button v-loading='loading' style="float:right;" @click="cancel()">{{$t('language.popup.remoteTaskPopup.cancelTask')}}</button>
        </div>
    </div>
</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
export default {
    data: function () {
        return {
            taskCancelShow: false,
			index:-1,
			item:null,
			loading:false
        }
    },
    methods: {
        cancel(){
			this.loading = true;
			if(this.index == -1 || this.item == null){
				this.loading = false;
				this.$toast({
					text: this.$t('language.exception.unknownError'),
					type: 'fail',
					idValue: "remoteTask"
				});
				return;
			}
			this.$parent.cancelRunRemoteTask(this.index, this.item);
		}
    }
}
</script>

<style>
#taskCancel {
    width: 416px;
    /*no*/
    height: 200px;
    /*no*/
}
.delete-content {
    width: 100%;
    /*no*/
    height: 90px;
    /*no*/
    font-size: 14px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
    box-sizing: border-box;
    padding: 0 20px 0 20px;
    /*no*/
    line-height: 90px;
    /*no*/

}

.delete-footer {
    width: 100%;
    height: 48px;
    /*no*/
    box-sizing: border-box;
    padding: 0 20px 0 20px;
    /*no*/
}

	#taskCancel .el-loading-spinner .path {
		stroke: #5166BD !important;
	}

	#taskCancel .el-table th>.cell {
		padding-right: 0 !important;
	}

	#taskCancel .el-loading-spinner .circular {
		height: 0.3rem !important;
		width: 0.3rem !important;
	}

	#taskCancel .el-loading-spinner {
		height: 30px;/*no*/
    top: 100%;
    margin-top: -0.3rem;
	}

</style>



// WEBPACK FOOTER //
// src/components/popup/remote_task_popups/task_cancel_popup.vue